/* eslint-disable new-cap */
import RouteForBUs from 'components/RouteWrappers/RouteForBUs';
import Loadable from 'react-loadable';

import Loading from './components/Loading/Loading';
import CanRoute from './components/RouteWrappers/CanRoute';
import StaffRoute from './components/RouteWrappers/StaffRoute';
import DefaultLayout from './containers/layouts/DefaultLayout';
import academyRoutes from './routes/academy';
import i9Routes from './routes/i9';
import Loader from './routes/Loader';
import auth from './services/Auth';

const GlobalDashboard = Loadable({
  loader: () => import('./views/Dashboard/Global/GlobalDashboard'),
  loading: Loader,
});

const IrisManagement = Loadable({
  loader: () => import('./views/Iris/IrisManagement'),
  loading: Loader,
});

const AgentsList = Loadable({
  loader: () => import('./views/Agents/AgentsList/AgentsList'),
  loading: Loader,
});

const AgentDetail = Loadable({
  loader: () => import('./views/Agents/AgentsList/Components/AgentDetails'),
  loading: Loader,
});

const LeadsList = Loadable({
  loader: () => import('./views/Leads/LeadsList/LeadsList'),
  loading: Loader,
});

const LeadsPipeline = Loadable({
  loader: () => import('./views/Leads/LeadsPipeline'),
  loading: Loader,
});

const Lead = Loadable({
  loader: () => import('./views/Leads/Lead'),
  loading: Loader,
});

const Trombinoscope = Loadable({
  loader: () => import('./views/Trombinoscope/Trombinoscope'),
  loading: Loader,
});

const DeletedUsersTrombinoscope = Loadable({
  loader: () => import('./views/Trombinoscope/AdminDeletedUsers/DeletedUsersTrombinoscope'),
  loading: Loader,
});

const Account = Loadable({
  loader: () => import('./views/Account/Account'),
  loading: Loading,
});

const Stats = Loadable({
  loader: () => import('./views/Stats/Stats'),
  loading: Loading,
});

const Valuation = Loadable({
  loader: () => import('./views/Properties/Valuation/Valuation'),
  loading: Loader,
});

const PropertyDetail = Loadable({
  loader: () => import('./views/Leads/Lead/PropertyDetail/PropertyDetailEdit'),
  loading: Loader,
});

const DrimkiOpportunitiesPage = Loadable({
  loader: () => import('./views/Opportunities/DrimkiOpportunitiesPage'),
  loading: Loader,
});

const PropertyList = Loadable({
  loader: () => import('./views/Properties/PropertyList'),
  loading: Loader,
});

const WorkflowList = Loadable({
  loader: () => import('./views/Workflow/WorkflowList/WorkflowList'),
  loading: Loader,
});

const WorkflowSteps = Loadable({
  loader: () => import('./views/Workflow/WorkflowSteps/WorkflowSteps'),
  loading: Loader,
});

const WorkflowAdd = Loadable({
  loader: () => import('./views/Workflow/WorkflowAdd/WorkflowAdd'),
  loading: Loader,
});

const Contact = Loadable({
  loader: () => import('./views/Contacts/Contact/Contact'),
  loading: Loader,
});

const ContactsList = Loadable({
  loader: () => import('./views/Contacts/ContactsList/ContactsList'),
  loading: Loader,
});

const UsersList = Loadable({
  loader: () => import('./views/Users/UsersList'),
  loading: Loader,
});

const CmsHub = Loadable({
  loader: () => import('./views/CMS/CmsHub'),
  loading: Loader,
});

const CmsTagHub = Loadable({
  loader: () => import('./views/CMS/CmsTagHub'),
  loading: Loader,
});

const CmsHubSlug = Loadable({
  loader: () => import('./views/CMS/CmsHubSlug'),
  loading: Loader,
});

const CapiDashboard = Loadable({
  loader: () => import('./views/Dashboard/Capifrance/CapiDashboard'),
  loading: Loader,
});

const OptimustDashboard = Loadable({
  loader: () => import('./views/Dashboard/Optimust/OptimustDashboard'),
  loading: Loader,
});

const StaffDashboard = Loadable({
  loader: () => import('./views/Dashboard/Staff/StaffDashboard'),
  loading: Loader,
});

const OptimhomeDashboard = Loadable({
  loader: () => import('./views/Dashboard/Optimhome/OptimhomeDashboard'),
  loading: Loader,
});

const CmsPage = Loadable({
  loader: () => import('./views/CMS/CmsPage'),
  loading: Loader,
});

const Sponsorship = Loadable({
  loader: () => import('./views/Sponsorship/Sponsorship'),
  loading: Loader,
});

const MLM = Loadable({
  loader: () => import('./views/MLM/MLM'),
  loading: Loader,
});

const Logout = () => {
  auth.logout();
  window.location.reload();
};

const Tracking = Loadable({
  loader: () => import('./views/TrackingUrl/Tracking'),
  loading: Loader,
});

const SignatureSheet = Loadable({
  loader: () => import('./views/SignatureSheet/SignatureSheet'),
  loading: Loader,
});

const Trainings = Loadable({
  loader: () => import('./views/Trainings/Trainings'),
  loading: Loader,
});

const PlanPerf = Loadable({
  loader: () => import('./views/PlanPerf/PlanPerf'),
  loading: Loader,
});

const PerformancePlan = Loadable({
  loader: () => import('./views/PerformancePlan/PerformancePlan'),
  loading: Loader,
});

const PerformancePlanCoach = Loadable({
  loader: () => import('./views/PerformancePlan/PerformancePlanCoach'),
  loading: Loader,
});

const PerformancePlanAgent = Loadable({
  loader: () => import('./views/PerformancePlan/PerformancePlanAgent'),
  loading: Loader,
});

// const DigitReAcademie = Loadable({
//   loader: () => import('./views/DigitReAcademie/DigitReAcademie'),
//   loading: Loader,
// });

const MonMarcheImmo = Loadable({
  loader: () => import('./views/MarcheImmo/MonMarcheImmo'),
  loading: Loader,
});

const MonMarcheImmoTabView = Loadable({
  loader: () => import('./views/MarcheImmo/MonMarcheTabView'),
  loading: Loader,
});

const PreAffectation = Loadable({
  loader: () => import('./views/Leads/PreAffectation/PreAffectation'),
  loading: Loader,
});

const ChallengesRankings = Loadable({
  loader: () => import('./views/Challenge/ChallengesRankings/index'),
  loading: Loader,
});

const DrimkiCgv = Loadable({
  loader: () => import('./views/Leads/PreAffectation/DrimkiCgv'),
  loading: Loader,
});

// const ChallengeLFP = Loadable({
//   loader: () => import('./views/ChallengeLFP/index'),
//   loading: Loader,
// });

// const ChallengeLFPStaff = Loadable({
//   loader: () => import('./views/ChallengeLFP/StaffDashboard'),
//   loading: Loader,
// });

const OptimhomeChallenge = Loadable({
  loader: () => import('./views/ChallengeOH/index'),
  loading: Loader,
});

const OptimhomeChallengeStaff = Loadable({
  loader: () => import('./views/ChallengeOH/StaffDashboard'),
  loading: Loader,
});
const Honoraires = Loadable({
  loader: () => import('./views/Honoraires/Honoraires'),
  loading: Loader,
});

const ObjectifsCoachs = Loadable({
  loader: () => import('./views/ObjectifsCoachs/ObjectifsCoachs'),
  loading: Loader,
});

const DevTeams = Loadable({
  loader: () => import('./views/ObjectifsCoachs/DevTeams'),
  loading: Loader,
});

const DevConstellation = Loadable({
  loader: () => import('./views/ObjectifsCoachs/DevConstellation'),
  loading: Loader,
});

const DevCaGlobal = Loadable({
  loader: () => import('./views/ObjectifsCoachs/DevCaGlobal'),
  loading: Loader,
});

const Quality = Loadable({
  loader: () => import('./views/ObjectifsCoachs/Quality'),
  loading: Loader,
});

const DepartureRate1 = Loadable({
  loader: () => import('./views/ObjectifsCoachs/DepartureRate1'),
  loading: Loader,
});

const DepartureRate2 = Loadable({
  loader: () => import('./views/ObjectifsCoachs/DepartureRate2'),
  loading: Loader,
});

const FormateurTerrain = Loadable({
  loader: () => import('./views/ObjectifsCoachs/FormateurTerrain'),
  loading: Loader,
});

const ExportSage = Loadable({
  loader: () => import('./views/Honoraires/ExportSage'),
  loading: Loader,
});

const HonorairesCoach = Loadable({
  loader: () => import('./views/Honoraires/HonorairesCoach'),
  loading: Loader,
});

const Commissionnement = Loadable({
  loader: () => import('./views/Commissionnement/Commissionnement'),
  loading: Loader,
});

const CommissionnementAtelier = Loadable({
  loader: () => import('./views/Commissionnement/CommissionnementAtelier'),
  loading: Loader,
});

const WorkshopBuilder = Loadable({
  loader: () => import('./views/Workshop/Builder'),
  loading: Loader,
});

const WorkshopBuilderUpsert = Loadable({
  loader: () => import('./views/Workshop/Builder/Upsert'),
  loading: Loader,
});

const WorkshopViewer = Loadable({
  loader: () => import('./views/Workshop/Viewer'),
  loading: Loader,
});

const Constellation = Loadable({
  loader: () => import('./views/Constellation/Constellation'),
  loading: Loader,
});

const Denounce = Loadable({
  loader: () => import('./views/Denounce/Denounce'),
  loading: Loader,
});

const IntermediaryBusiness = Loadable({
  loader: () => import('./views/IntermediaryBusiness/IntermediaryBusiness'),
  loading: Loader,
});

const IntermediaryBusinessConfiguration = Loadable({
  loader: () => import('./views/IntermediaryBusiness/Configuration'),
  loading: Loader,
});

const IntermediaryBusinessValidation = Loadable({
  loader: () => import('./views/IntermediaryBusiness/Validation'),
  loading: Loader,
});

const IntermediaryBusinessCGV = Loadable({
  loader: () => import('./views/IntermediaryBusiness/CGV'),
  loading: Loader,
});

const RecruitmentDashboardAdmin = Loadable({
  loader: () => import('./views/Recruitment/DashboardAdmin'),
  loading: Loader,
});

const MailSignature = Loadable({
  loader: () => import('./views/MailSignature/MailSignature'),
  loading: Loader,
});

const CreativeStudio = Loadable({
  loader: () => import('./views/CreativeStudio/CreativeStudio'),
  loading: Loader,
});

const QrCodeGenerator = Loadable({
  loader: () => import('./views/CreativeStudio/QrCode/QrCode'),
  loading: Loader,
});

const PrintMediaKitStudio = Loadable({
  loader: () => import('./views/CreativeStudio/PrintMediaKit/PrintMediaKit'),
  loading: Loader,
});

const LeaderConstellation = Loadable({
  loader: () => import('./views/Pages/Leader/LeaderConstellation'),
  loading: Loader,
});

const LeaderSponsorship = Loadable({
  loader: () => import('./views/Pages/Leader/LeaderSponsorship'),
  loading: Loader,
});

const LeaderMlm = Loadable({
  loader: () => import('./views/Pages/Leader/LeaderMlm'),
  loading: Loader,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Dashboard', component: DefaultLayout, exact: true },
  { path: '/dashboard/default', name: '', component: GlobalDashboard },
  { path: '/dashboard/staff', name: '', component: StaffDashboard },
  { path: '/dashboard/optimhome', name: 'Accueil OptimhomeDashboard', component: OptimhomeDashboard },
  { path: '/dashboard/capifrance', name: 'Accueil Capifrance', component: CapiDashboard },
  { path: '/dashboard/optimust', name: 'Accueil Optimust', component: OptimustDashboard },
  { path: '/iris', name: 'Gestion des iris', component: IrisManagement },
  { path: '/property/valuation/:id', name: 'Avis de valeur', component: Valuation },
  { path: '/property/:id', name: 'Bien', component: PropertyDetail },
  { path: '/property', name: 'Gestion des biens', component: PropertyList },
  { path: '/viager/:id/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/viager/:id', name: 'Créer un viager', component: Lead },
  { path: '/viager', name: 'Viager', component: LeadsList },
  { path: '/presale/:id/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/presale/:id/contact' },
  { path: '/presale/:id', name: 'Prévente', component: Lead },
  { path: '/presale', name: 'Gestion des préventes', component: LeadsList },
  { path: '/precisio/:id/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/precisio/:id/contact' },
  {
    path: '/precisio/:id',
    name: 'Créer un avis de valeur Précisio',
    component: Lead,
    customTitle: () => 'PRECISIO page [tab_property]',
  },
  { path: '/precisio', name: 'Precisio', component: LeadsList, customTitle: () => 'PRECISIO list' },
  { path: '/valorize/:id/contact/:idContact', name: 'Contact', component: Contact },
  {
    path: '/valorize/:id',
    name: 'Créer un dossier Valorize',
    component: Lead,
    customTitle: () => 'VALORIZE page [tab_property]',
  },
  { path: '/valorize', name: 'Valorize', component: LeadsList, customTitle: () => 'VALORIZE list' },
  { path: '/dili/:id/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/dili/:id', name: 'Opportunité', component: Lead },
  { path: '/dili/:referer', name: 'Gestion des opportunités Dili', component: Lead },
  { path: '/dili', name: 'Opportunités', component: LeadsList },
  { path: '/drimki/ads_requests/:id/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/drimki/ads_requests/:id', name: 'Annonce', component: Lead },
  { path: '/drimki/ads_requests', name: 'ToutvaBiens Annonces', component: DrimkiOpportunitiesPage },
  { path: '/pipeline/:referer', name: 'Opportunités', component: LeadsPipeline },
  { path: '/stats', name: 'Statistiques', component: Stats },
  { path: '/stats/*', name: 'Statistiques', component: Stats },
  { path: '/account', name: 'Mon profil', component: Account },
  { path: '/account/*', name: 'Mon profil', component: Account },
  { path: '/workflows/:id', name: 'Étapes du workflow', component: WorkflowSteps },
  { path: '/workflows', name: 'Liste des workflows', component: WorkflowList },
  { path: '/workflow/add', name: 'Ajouter un workflow', component: WorkflowAdd },
  { path: '/contact/:idContact', name: 'Contact', component: Contact },
  { path: '/contact', name: 'Gestion des contacts', component: ContactsList },
  { path: '/users', name: 'Gestion des utilisateurs', component: UsersList },
  {
    path: '/cms/page/:id',
    name: 'Page CMS',
    component: CmsPage,
    customTitle: ({ id }) => {
      return (
        {
          2223: 'aide_creation_entreprise',
          2181: 'visuel_parrainage',
          2208: 'statut_tva',
          2284: 'formation_opteamleader',
          2288: 'support_print',
          2191: 'support_recrutement',
          1715: 'support_RS',
        }[id] ?? `Page CMS`
      );
    },
  },
  { path: '/cms/tag/:slug', name: 'CMS Tag Hub', component: CmsTagHub },
  {
    path: '/cms/hub/:id',
    name: 'CMS HUB',
    component: CmsHub,
    customTitle: ({ id }) => {
      return (
        {
          2059: 'HUB_ESPACE_LEADER',
          2092: 'outil_recrutement',
          2111: 'outils_suivi',
          889: 'HUB_parrainage_cooptation',
          2263: 'HUB_quartier_opteamleader',
          2275: 'HUB_vie_opteamleader',
          2277: 'attirer_nvx_candidats',
        }[id] ?? `Page HUB`
      );
    },
  },
  { path: '/cms/slug/:slug', name: 'CMS HUB', component: CmsHubSlug },
  { path: '/logout', name: 'Déconnexion', component: Logout },
  { path: '/sponsorship', name: 'Parrainage', component: Sponsorship },
  { path: '/mlm', name: 'MLM', component: MLM },
  { path: '/marketing-tools/url-tracking-generator', name: "Générateur d'url de tracking", component: Tracking },
  { path: '/trombi', name: 'Trombinoscope', component: Trombinoscope },
  { path: '/deleted-users-trombi', name: 'Trombinoscope', component: DeletedUsersTrombinoscope },
  { path: '/plan-performance/:agentId', name: 'Plan de Performance V2', component: PlanPerf },
  {
    path: '/plan-performance',
    name: 'Plan de Performance V2',
    component: PlanPerf,
    customTitle: () => 'home_page_pdp',
  },
  { path: '/performance-plan', name: 'Plan de Performance', component: PerformancePlan },
  { path: '/performance-plan-coach', name: 'Plan de Performance coach', component: PerformancePlanCoach },
  { path: '/performance-plan-agent', name: 'Plan de Performance coach', component: PerformancePlanAgent },
  { path: '/signature-sheet', name: "Feuille d'émargement", component: SignatureSheet },
  { path: '/trainings', name: 'Parcourir les formations', component: Trainings },
  //{ path: '/digitreacademie', name: 'DigitReAcademie', component: DigitReAcademie },
  { path: '/monmarcheimmo', name: 'Mon Marche Immo', component: MonMarcheImmo },
  { path: '/monmarcheimmoinfos/:zipcode', name: 'Mon Marche Immo', component: MonMarcheImmoTabView },
  { path: '/pre-affectation/:id', name: 'PreAffectation', component: PreAffectation },
  { path: '/cgv-drimki', name: 'CGV ToutvaBiens', component: DrimkiCgv },
  { path: '/workshop/builder/add', name: "Ajout d'atelier", component: WorkshopBuilderUpsert },
  { path: '/workshop/builder/edit/:workshopId', name: "Modification d'atelier", component: WorkshopBuilderUpsert },
  { path: '/workshop/builder', name: "Gestion d'atelier", component: WorkshopBuilder },
  { path: '/workshop/viewer', name: 'Atelier', component: WorkshopViewer },
  { path: '/constellation', name: 'Constellation', component: Constellation },
  { path: '/list_attribution', name: 'Opportunités Drimki', component: LeadsList },
  { path: '/leader/constellation', name: 'Leader Constellation', component: LeaderConstellation },
  { path: '/leader/sponsorship', name: 'Leader Parainage', component: LeaderSponsorship },
  { path: '/leader/plan-performance/:agentId', name: 'Leader Plan de Performance V2', component: PlanPerf },
  { path: '/leader/plan-performance', name: 'Leader Plan De Performance', component: PlanPerf },
  { path: '/leader/mlm', name: 'Leader Multi Level Marketing', component: LeaderMlm },
  { path: '/challenges/capifrance/:year', name: 'Challenges', component: ChallengesRankings },
  {
    path: '/challenge/optimhome',
    name: 'Challenges OH',
    component: OptimhomeChallenge,
    customTitle: () => `Challenge OH ${new Date().getFullYear()}`,
  },
  { path: '/challenge/staff/optimhome', name: 'Challenges OH Staff', component: OptimhomeChallengeStaff },
  { path: '/honoraires/coach/:id/:period', name: 'Honoraires Coach', component: HonorairesCoach },
  { path: '/agent/:id', name: 'Détail du conseiller', component: AgentDetail },
  { path: '/agent', name: 'Liste des conseillers', component: AgentsList, wrapper: StaffRoute },
  {
    path: '/honoraires',
    name: 'Honoraires',
    component: Honoraires,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'honoraires' },
  },
  {
    path: '/objectifs-coachs-admin',
    name: 'Admin objectifs coachs',
    component: ObjectifsCoachs,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/developpement-constellation-admin',
    name: 'Admin developpement constellation',
    component: DevConstellation,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/developpement-ca-global-admin',
    name: 'Admin developpement ca global',
    component: DevCaGlobal,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/developpement-equipes-admin',
    name: 'Admin développement équipe',
    component: DevTeams,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/quality-admin',
    name: 'Admin garantie de la qualité',
    component: Quality,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/departure-rate-1-admin',
    name: 'Admin maîtrise du taux de départ 1',
    component: DepartureRate1,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/departure-rate-2-admin',
    name: 'Admin maîtrise du taux de départ 2',
    component: DepartureRate2,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/formateur-terrain-admin',
    name: 'Admin formateur terrain',
    component: FormateurTerrain,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'objectifs_coachs' },
  },
  {
    path: '/exportSage',
    name: 'Export Sage',
    component: ExportSage,
    wrapper: CanRoute,
    wrapperArgs: { rule: 'access', subject: 'honoraires' },
  },
  { path: '/commissionnements/:year/:contactInfoId', name: 'Commissionnement', component: Commissionnement },
  {
    path: '/commissionnements-atelier/:year/:zipcodeAtelier',
    name: 'Commissionnement Atelier',
    component: CommissionnementAtelier,
  },
  { path: '/denounce', name: 'Dénonce', component: Denounce },
  {
    path: '/intermediary-business/validation/:state/:assocId',
    name: "Apporteur d'affaires",
    component: IntermediaryBusinessValidation,
  },
  { path: '/intermediary-business/configuration', name: 'Configuration', component: IntermediaryBusinessConfiguration },
  { path: '/intermediary-business/cgv', name: 'Configuration', component: IntermediaryBusinessCGV },
  { path: '/intermediary-business', name: "Apporteur d'affaires", component: IntermediaryBusiness },
  { path: '/recruitment/admin', name: 'Recrutement admin', component: RecruitmentDashboardAdmin },
  { path: '/generateursignature', name: 'Générateur de Signature', component: MailSignature },
  { path: '/creative-studio/qr-generator', redirectTo: '/qr-code-generator' },
  { path: '/qr-code-generator', name: 'Générateur de QR code', component: QrCodeGenerator },

  // -------- ASSET EDITOR --------
  // For Capifrance
  {
    path: '/le-studio/print-media',
    name: 'Print Media Kit',
    component: PrintMediaKitStudio,
    wrapper: RouteForBUs,
    wrapperArgs: { allowedBUs: 'capifrance' },
  },
  {
    path: '/le-studio',
    name: 'Creative studio',
    component: CreativeStudio,
    wrapper: RouteForBUs,
    wrapperArgs: { allowedBUs: 'capifrance' },
  },
  // For Optimhome
  {
    path: '/creative-studio/print-media',
    name: 'Print Media Kit',
    component: PrintMediaKitStudio,
    wrapper: RouteForBUs,
    wrapperArgs: { allowedBUs: 'optimhome' },
  },
  {
    path: '/creative-studio',
    name: 'Creative studio',
    component: CreativeStudio,
    wrapper: RouteForBUs,
    wrapperArgs: { allowedBUs: 'optimhome' },
  },
  // -------- END ASSET EDITOR --------

  ...academyRoutes,
  ...i9Routes,
];

export default routes;
